import { render } from "./TheaterBio.vue?vue&type=template&id=5a7daa86"
import script from "./TheaterBio.vue?vue&type=script&lang=js"
export * from "./TheaterBio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__